  import { Routes } from '@angular/router';
import { AuthGuard } from '../../shared/authguards/auth.guard';
import { paidCustomerGuard } from '../../shared/authguards/paid-customer.guard';

export const PAID_ROUTES: Routes = [
  {
    path: "paid",
    loadComponent: () => import("./paid-wrapper.component").then(m => m.PaidWrapperComponent),
    canActivate: [AuthGuard, paidCustomerGuard],
    children: [
      {
        path: "",
        loadComponent: () => import("./paid-component/paid.component").then(m => m.PaidComponent),
        data: { title: "pageTitles.premiumPage" },
      },
      {
        path: "select-provider/:serviceType",
        loadComponent: () => import("./select-provider/select-provider.component").then(m => m.SelectProviderComponent),
        data: { title: "services.selectProviderTitle" },
      },
      {
        path: "info",
        loadComponent: () => import("./paid-services-info/paid-services-info.component").then(m => m.PaidServicesInfoComponent),
        data: { title: "paidServicesInfo.title" },
      },
      {
        path: "prescription-info",
        loadComponent: () => import("./important-info-pages/prescription-important-info/prescription-important-info.component").then(m => m.PaidPrescriptionImportantInfoComponent),
        data: { title: "pageTitles.prescriptionInfo" },
      },
      {
        path: "consultation-info",
        loadComponent: () => import("./important-info-pages/consultation-important-info/consultation-important-info.component").then(m => m.ConsultationImportantInfoComponent),
        data: { title: "pageTitles.diseaseInfo" },
      },
      {
        path: "examination-info",
        loadComponent: () => import("./important-info-pages/examination-important-info/examination-important-info.component").then(m => m.ExaminationImportantInfoComponent),
        data: { title: "pageTitles.examinationInfo" },
      },
      {
        path: "lyfery-info",
        loadComponent: () => import("./important-info-pages/lyfery-important-info/lyfery-important-info.component").then(m => m.LyferyImportantInfoComponent),
        data: { title: "pageTitles.lyferyInfo" },
      },
      {
        path: "message",
        loadComponent: () => import("./paid-chat-messages/paid-chat-messages.component").then(m => m.PaidChatMessagesComponent),
        data: { title: "pageTitles.message" },
      },
      {
        path: "my-paid-services",
        loadComponent: () => import("../paid-services/my-paid-services/my-paid-services.component").then(m => m.MyPaidServicesComponent),
        data: { title: "pageTitles.myPaidServices" },
      },
      {
        path: "weight-info",
        loadComponent: () => import("./weight-info/weight-info").then(m => m.WeightInfo),
        data: { title: "pageTitles.weightInfo" },
      },
    ],
  },
];
